import { createDomain } from 'effector';

const domain = createDomain('global/update-subscription-items-modal');

if (process.env.NODE_ENV === 'development') {
    // @ts-ignore
    import('effector-logger/attach').then((module) => module.attachLogger(domain));
}

export default domain;
